export { PageTopicsFormComponent as PageTopicsDetail } from './component';


// WEBPACK FOOTER //
// ./src/pages/topics-form/index.tsx